import VibeCard from "./VibeCard";
import { AnimatePresence } from "framer-motion";

/**
 * ModeStrip — colored section within the feed (Local Perks, Opportunity, etc.).
 * Renders a list of VibeCards under a tinted header. Uses <AnimatePresence>
 * so new vibes slide in and existing ones smoothly reflow (conveyor belt).
 */
export default function ModeStrip({ label, sublabel, accent, vibes, blink, testid }) {
  return (
    <div
      className="mt-4 rounded-3xl border bg-black/50 p-4 relative"
      style={{ borderColor: `${accent}55`, boxShadow: `0 0 24px ${accent}22` }}
      data-testid={testid}
    >
      <div className="flex items-baseline justify-between">
        <div className="flex items-center gap-2">
          <span style={{ color: accent }}>●</span>
          <span className="font-mono-accent" style={{ color: accent, letterSpacing: "0.25em" }}>{label}</span>
        </div>
        <span className="text-[0.6rem] text-zinc-500 font-light">{sublabel}</span>
      </div>
      <div className="mt-3 space-y-3">
        <AnimatePresence initial={false}>
          {vibes.map(v => <VibeCard key={v.id} v={v} blink={blink} />)}
        </AnimatePresence>
      </div>
    </div>
  );
}
